import { SYSTEM_ORG_UUID } from "@/lib/supabase/supabaseClient";

export type OrgLibraryItem = {
  org_id?: string | null;
  created_by?: string | null;
};

export type OrgLibraryAccessOptions = {
  userId?: string | null;
  canManageLibrary: boolean;
};

export const isSystemLibraryItem = (item: Pick<OrgLibraryItem, "org_id">) =>
  item.org_id === SYSTEM_ORG_UUID;

export const canEditOrgLibraryItem = (
  item: OrgLibraryItem | undefined,
  { userId, canManageLibrary }: OrgLibraryAccessOptions,
) => {
  if (!item) {
    return true;
  }
  if (isSystemLibraryItem(item)) {
    return false;
  }
  if (canManageLibrary) {
    return true;
  }
  return Boolean(userId) && item.created_by === userId;
};

export const canDeleteOrgLibraryItem = canEditOrgLibraryItem;
